module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagey"
  }, [_c('a', {
    attrs: {
      "id": "page_xii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "blockquotex"
  }, [_c('em', [_vm._v("Think of those old, enduring connections found in all flesh—the channeling wires and threads, vacuoles, granules, plasma and pods, purple veins, ascending boles and coral sapwood (sugar- and light-filled), those common ligaments, filaments, fibers and canals")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "chapauthorx"
  }, [_vm._v("—from “The Family Is All There Is” by Pattiann Rogers")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7565d044","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm3.vue
// module id = 87
// module chunks = 0